import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ReadPage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface IncludePageParams {
  pageId: string;
}

export const includePage = async (params: IncludePageParams): Promise<ReadPage> => {
  return await tinctApi.pages.includePage(params.pageId);
};

export const useIncludePage = (
  options?: Omit<
    UseMutationOptions<ReadPage, ApiError, IncludePageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: includePage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      queryClient.invalidateQueries({ queryKey: ['campaign'] });
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
